export const strategies = {
    customerWishlist: process.env.REACT_APP_CUSTOMER_FAVORITES_STRATEGY,
    recentlyViewed: process.env.REACT_APP_RECENTLY_VIEWED_STRATEGY,
    onboardingStrategy: process.env.REACT_APP_PROMOTIONS_ONBOARDING_STRATEGY,
    gsCrossSellStrategy: process.env.REACT_APP_GS_CROSS_SELL_STRATEGY,
    pointsToSpendStrategy: process.env.REACT_APP_POINTS_TO_SPEND_STRATEGY
};
